import {useEffect, useMemo, useState} from "react";
import {Alert, Button, Col, Form,  Row, Table} from "react-bootstrap";
import {useAuth} from "../../providers/authprovider";
import useAlert from "../../components/CustomAlert";
import {v4 as uuidv4} from "uuid";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExport, faFileImport, faTrash} from "@fortawesome/free-solid-svg-icons";
import SearchField from "../../components/SearchField";

export default function Assortments(props){
    const {assortments : {get, save, exportAssortments, uploadAssortments}, saveFile} = useAuth();
    const {alert, showAlert} = useAlert();
    const [dirtyState, setDirty] = useState(false)
    const [assortments, setAssortments] = useState(undefined);
    const [searchQuery, setSearchQuery] = useState('');
    const assortmentsMemo = useMemo(()=>{
        if(!searchQuery || searchQuery.length === 0)
            return assortments;

        const re = new RegExp(searchQuery, 'gi');

        return assortments.filter(a=>re.test(a.name));
    }, [assortments, searchQuery])

    useEffect(()=>{
        if(assortments !== undefined)
            return;

        get(({success, error, content})=>{
            if(success)
                return setAssortments(content)

            if(error)
                return showAlert(error)
        })
    })

    const addRow = ()=>{
        setAssortments(prevState=>{
            if(prevState === undefined)
                prevState = [];

            return [{id:uuidv4(),group:"", name:"", price:0}, ...prevState];
        })
    }

    const handleChangeElement = (event, element)=>{
        const name = event.target.name;
        element[name] = event.target.value;

        setAssortments([...assortments])
        setDirty(true)
    }

    const deleteAssortment = (id)=>{
        setAssortments(prevState=>{
            setDirty(true)
            return [...prevState.filter(a=>a.id !== id)]
        })
    }

    const handleSave = ()=>{

        save(assortments, ({success, error, content})=>{
            if(error)
                return showAlert(error);// jebac PIS

            setDirty(false);
        })
    }

    /**
     * Select file(s).
     * @param {String} contentType The content type of files you wish to select. For instance, use "image/*" to select all types of images.
     * @param {Boolean} multiple Indicates if the user can select multiple files.
     * @returns {Promise<File|File[]>} A promise of a file or array of files in case the multiple parameter is true.
     */
    function selectFile(contentType, multiple){
        return new Promise(resolve => {
            let input = document.createElement('input');
            input.type = 'file';
            input.multiple = multiple;
            input.accept = contentType;

            input.onchange = () => {
                let files = Array.from(input.files);
                if (multiple)
                    resolve(files);
                else
                    resolve(files[0]);
            };

            input.click();
        });
    }

    function uploadExcelAssortments(file){

        const formdata = new FormData();
        formdata.append("file", file); // <-- server expects `file` to hold name


        uploadAssortments(formdata, ({success, error, content})=>{

            if(!success)
                return showAlert(error)

            setAssortments([...content])
            console.log(success, error, content);
        })
    }

    const handleExportAssortments = ()=>{
        exportAssortments(({success, error, content})=>{
            console.log(success, error, content);

            if(success)
                return saveFile("Asortymenty.xlsx", content.type, content.file );
        })
    }

    return (
        <div className={"container p-2"}>
            {alert()}
            <Row >
                <Col>
                    <SearchField onSearch={(query)=>{setSearchQuery(query)}} />
                </Col>
                <Col className={"text-end"}>
                    <Button variant={"outline-dark"} className={"me-4"} title={"Import danych z pliku"} onClick={async ()=>{
                        const file = await selectFile("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel", false);

                        if(file)
                            uploadExcelAssortments(file)


                    }}><FontAwesomeIcon icon={faFileImport} /> import</Button>
                    <Button variant={"outline-dark"}  title={"Eksport do pliku"} onClick={handleExportAssortments}><FontAwesomeIcon icon={faFileExport} /> export</Button>
                </Col>
            </Row>
            {
                dirtyState &&
                <Alert variant={"info"} >
                    <div><b>Uwaga</b><br/> Wprowadzono zmiany - zapisz aby zapamiętać.</div>
                    <div className={"text-end"}>
                        <Button  variant={"outline-secondary"} onClick={handleSave}>Zapisz</Button>
                    </div>

                </Alert>
            }
            <Table bordered hover >
                <thead>
                    <tr>
                        <th width={75}>L.p.</th>
                        <th>Grupa</th>
                        <th>Nazwa</th>
                        <th>
                            <div className={"d-flex justify-content-between align-bottom"}>
                                <span>Cena katalogowa</span>
                                <Button size={"sm"}  variant={"outline-primary"} onClick={addRow}>Dodaj</Button>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                {
                    assortmentsMemo?.map((a, i)=>{
                        return  <tr key={i}>
                                    <td>{i+1}</td>
                                    <td>
                                        <Form.Select name={"group"} value={a.group} onChange={(e)=>handleChangeElement(e, a)} >
                                            <option ></option>
                                            <option value={"aeration"}>napowietrzanie</option>
                                            <option value={"garages"}>garaże</option>
                                            <option value={"installation"}>montaż</option>
                                            <option value={"service"}>serwis</option>
                                        </Form.Select>
                                    </td>
                                    <td><Form.Control type={"text"} value={a.name} name={"name"} onChange={(e)=>handleChangeElement(e, a)} /></td>
                                    <td><Form.Control type={"number"} min={0} value={a.price} name={"price"} onChange={(e)=>handleChangeElement(e, a)} /></td>
                                    <td className={"text-end"}><Button size={"sm"} variant={"outline-secondary"} onClick={()=>deleteAssortment(a.id)} title={"Usuń"}><FontAwesomeIcon icon={faTrash} /></Button> </td>
                        </tr>
                    })
                }
                </tbody>
            </Table>
        </div>
    )
}